import { RESET_STORE } from "./rootActionTypes";
   
  export const resetStore = () => {
    return {
      type: RESET_STORE
    }
  }